
import { Notification } from "@/models/notifications/notification";
import Vue from "vue";
import { AuthService } from "@/services/auth-service";
import {NotificationService} from "@/services";
import { formatNotificationTime } from "@/utils/notification-time";

export default Vue.extend({
	data() {
		return {
			displayError: false,
		};
	},
	props: {
		value: {
			type: Object as () => Notification,
			required: true
		},
		// Aantal identieke meldingen dat deze rij vertegenwoordigt
		count: {
			type: Number,
			default: 1
		},
		expanded: Boolean
	},
	computed: {
		time():string {
			return formatNotificationTime(this.value.Date, this.$i18n.locale);
		},
		message():string {
			return (this.value.getMessage() || "").trim();
		},
		actionLabel():string {
			let key = this.value.getActionKey();
			if (!key) return "";
			return this.$t(`common.notification-actions.${key}`).toString();
		},
		hideIcon():string{
			if (this.value.HideForClient) {
				return "eye-slash";
			}
			return "eye";
		},
		hideTooltip():string {
			if (this.value.HideForClient) {
				return "Tonen voor gebruiker";
			}
			return "Verbergen voor gebruiker";
		},
		showHideForClientButton():boolean {
			return AuthService.isDevModeEnabled;
		},
		isJobStoppedMessage():boolean {
			if (this.value.Message != "message-job-crashed") return false;
			if (this.value.Type != "error") return false;
			if (typeof(this.value.Data) != "object") return false;
			return this.value.Data["Error"] == "Job is cancelled";
		}
	},
	methods: {
		onItemClick() {
			if (this.count > 1) {
				this.$emit("toggle");
				return;
			}
			this.onClick();
		},
		// eslint-disable-next-line max-lines-per-function
		async onClick() {
			let result = await this.value.onClick(this);
			if (result.routeTo) {
				this.$router.push(result.routeTo);
				this.$emit("close");
			}
			if (result.closeNotificationModal) {
				this.$emit("close");
			}
			if (result.openReportDownload) {
				this.$emit("open-report-download", this.value);
			}
			if (this.value.Type == "error"){
				this.displayError = !this.displayError;
			}
		},
		async onHideClick(){
			let result = await NotificationService.setHideFromClient(this.value, !this.value.HideForClient);
			this.value.HideForClient = result.HideForClient;
		}
	}
});
